import { render, staticRenderFns } from "./block-rawhtml.vue?vue&type=template&id=11a9c2a2"
import script from "./block-rawhtml.vue?vue&type=script&lang=js"
export * from "./block-rawhtml.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports